// #516 rodada 3 (arbitro Grok, mandato final — 3a e ultima rodada do card).
//
// Defeito fechado aqui: RuleBenefitReportModal.vue busca `getRuleBenefit` e
// SUBSTITUI `this.rule.benefitLogs` inteiro pelo retorno do endpoint
// (CalculationController.js:645/:1264-1316). Esse endpoint devolve os logs
// SEM os campos `display*` — só `rule` (que chega enriquecido pelo motor via
// `enrichDisplayAge`, api/context/calculator.js:84-119) os tem. Sem este
// merge, a substituicao apaga display* e o computed `necessaryAgeDisplay`
// (RuleBenefitReportModal.vue) cai no ramo `isLegacyLog`, voltando a exibir a
// idade CRUA (`necessaryAge`) — exatamente o que a espec #516 proibe.
//
// PROIBIDO (mandato do arbitro): fazer o endpoint calcular/devolver os
// display* (criaria uma 5a replica da mesma logica) e mexer em
// `necessaryAge` ou em CalculationController.js:1042. A unica correcao
// autorizada e este merge no front, no momento em que `benefitLogs` e
// substituido.
//
// Extraido como funcao pura (fora do componente Vue) porque o projeto nao
// tem harness de teste para componentes Vue — só assim da pra cobrir o
// merge com mocha, sem dependencia nova (mesma solucao aprovada pelo
// arbitro no card #538).

const DISPLAY_AGE_FIELDS = [
  'displayNecessaryAge',
  'displayNecessaryAgeMonths',
  'displayNecessaryAgeDays',
];

/**
 * Devolve uma copia de `logs` com os campos display* de idade copiados de
 * `rule` sempre que `rule` os tiver definidos (inclusive 0 — idade minima
 * pode legitimamente ser 0 meses/dias). `logs` nunca e mutado.
 *
 * @param {Object} rule - `this.rule` do modal, ja enriquecido pelo motor.
 * @param {Object} logs - retorno cru de `getRuleBenefit` (response.logs).
 * @returns {Object} novo objeto de logs com display* preservados.
 */
function mergeDisplayAgeFields(rule, logs) {
  const merged = Object.assign({}, logs || {});

  DISPLAY_AGE_FIELDS.forEach((field) => {
    if (rule && rule[field] !== undefined) {
      merged[field] = rule[field];
    }
  });

  return merged;
}

module.exports = {
  DISPLAY_AGE_FIELDS,
  mergeDisplayAgeFields,
};
